import {WebClient} from "../../store/clients/client";
import {
    AdminCompatabilityMatrixResponse,
    BuildVersionCompatability,
    UserCompatabilityMatrixResponse
} from "../../models/build";

// ---------------------------------------- ADMIN ----------------------------------------
export async function adminNewBuildVersionCompatibility(comp: BuildVersionCompatability): Promise<BuildVersionCompatability> {
    try {
        const response = await WebClient.AdminNewBuildVersionCompatibility(comp);

        if (response.status === 200 || response.status === 201) {
            return response.data as BuildVersionCompatability;
        }
    } catch (e) {}

    return {} as BuildVersionCompatability;
}

export async function adminGetBuildVersionCompatibility(server_version?: string, client_version?: string): Promise<AdminCompatabilityMatrixResponse> {
    try {
        const response = await WebClient.AdminGetBuildVersionCompatibility(server_version, client_version);

        if (response.status === 200) {
            return response.data as AdminCompatabilityMatrixResponse;
        }
    } catch (e) {}

    return {} as AdminCompatabilityMatrixResponse;
}

export async function adminModifyBuildVersionCompatibility(comp: BuildVersionCompatability): Promise<BuildVersionCompatability> {
    try {
        const response = await WebClient.AdminModifyBuildVersionCompatibility(comp);

        if (response.status === 200) {
            return response.data as BuildVersionCompatability;
        }
    } catch (e) {}

    return {} as BuildVersionCompatability;
}

export async function adminDeleteBuildVersionCompatibility(server_version: string, client_version: string): Promise<boolean> {
    try {
        const response = await WebClient.AdminDeleteBuildVersionCompatibility(server_version, client_version);

        if (response.status === 204) {
            return true;
        }
    } catch (e) {}

    return false;
}

// ---------------------------------------- USER ----------------------------------------
export async function userGetBuildVersionCompatibility(): Promise<UserCompatabilityMatrixResponse> {
    try {
        const response = await WebClient.UserGetBuildVersionCompatibility();

        if (response.status === 200) {
            return response.data as UserCompatabilityMatrixResponse;
        }
    } catch (e) {}

    return {} as UserCompatabilityMatrixResponse;
}

// ---------------------------------------- PUBLIC ----------------------------------------
export async function publicGetBuildVersionCompatibility(): Promise<UserCompatabilityMatrixResponse> {
    try {
        const response = await WebClient.PublicGetBuildVersionCompatibility();

        if (response.status === 200) {
            return response.data as UserCompatabilityMatrixResponse;
        }
    } catch (e) {}

    return {} as UserCompatabilityMatrixResponse;
}
